import { FC, useEffect, useState } from 'react';
import { AlertFooter } from '../../../components/AlertFooter';
import { Button } from '../../../components/Button';
import { TextArea } from '../../../components/TextArea';
import {
  closeEditNote,
  saveTripNote,
  useEditNoteAlertState,
} from '../../../services/history';
import { HistoryAlertEdit } from '../HistoryAlertEdit';
import { FormattedMessage } from 'react-intl';

interface EditNoteProps {}

export const EditNote: FC<EditNoteProps> = () => {
  const state = useEditNoteAlertState();
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(state?.flatTrip.note ?? '');
  }, [state?.flatTrip.note]);

  if (!state) {
    return null;
  }

  return (
    <HistoryAlertEdit
      open
      onClose={closeEditNote}
      title={
        <label htmlFor="trip-note">
          <FormattedMessage id="Notes" />
        </label>
      }
      description={
        <>
          <FormattedMessage id="Notes.Alert" />:
        </>
      }
    >
      <TextArea
        id="trip-note"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        rows={5}
      ></TextArea>
      <AlertFooter>
        <Button variant="text" onClick={closeEditNote}>
          <FormattedMessage id="Cancel" />
        </Button>
        <Button onClick={() => saveTripNote(value)}>
          <FormattedMessage id="Save" />
        </Button>
      </AlertFooter>
    </HistoryAlertEdit>
  );
};
